module.exports = __webpack_public_path__ + "static/media/saudi-arabia.efc3d0b2.svg";